module.exports = __webpack_public_path__ + "media/images/es/prize-title-f273469e123d6e6742222dc1d3f84146.png";